/** turbopuffer-internal workspace. */
const SLACK_TEAM_ID = "T064FKB9PU1";

/** Opens a channel in the Slack app from its ID, or from a legacy #name via the web redirect. */
export function slackChannelUrl(channel: string): string {
  if (/^[CG][A-Z0-9]+$/.test(channel)) {
    return `slack://channel?team=${SLACK_TEAM_ID}&id=${channel}`;
  }
  return `https://slack.com/app_redirect?channel=${encodeURIComponent(channel)}`;
}
